function switchAllCheckbox(targetName) {
  if (document.querySelector(`.checkbox_for_${targetName}_all_search`)) {
    document.querySelector(`.checkbox_for_${targetName}_all_search`).addEventListener('click', (e) => {
      // 全てをチェックされた場合、子要素を全てcheckする
      document.querySelectorAll(`.checkbox_for_${targetName}_id_search`).forEach((element) => {
        element.checked = e.target.checked;
      });
    });

    document.querySelectorAll(`.checkbox_for_${targetName}_id_search`).forEach((e) => {
      e.addEventListener('click', () => {
        const checkBoxes = document.querySelectorAll(`.checkbox_for_${targetName}_id_search`);
        if (document.querySelectorAll(`.checkbox_for_${targetName}_id_search:checked`).length == checkBoxes.length) {
          document.querySelector(`.checkbox_for_${targetName}_all_search`).checked = true;
        } else {
          document.querySelector(`.checkbox_for_${targetName}_all_search`).checked = false;
        }
      });
    });
  }
}

switchAllCheckbox('area', '');
switchAllCheckbox('category', '');
switchAllCheckbox('tag', '');
